import { elements } from '../components/Driver/AwDriverContext'

export default {
  mounted(el, binding) {
    elements.add(binding.value)
    el.setAttribute('data-driver-element', binding.value)
  },
  unmounted(el, binding) {
    elements.delete(binding.value)
    el.removeAttribute('data-driver-element')
  }
}
